import * as React from "react"
import { SvgActivity } from "@digits-shared/components/SVGIcons/line/Activity.svg"
import { Checkbox as FilterCheckbox } from "@digits-shared/DesignSystem/FormElements/Checkbox"
import colors from "@digits-shared/themes/colors"
import styled from "styled-components"
import { DimensionActivity } from "src/frontend/types/DimensionFilter"
import {
  FilterAccordionContent,
  FilterAccordionHeader,
  FilterAccordionItem,
} from "src/shared/components/Filters/FilterAccordion"
import { FilterContentSection } from "src/shared/components/Filters/shared"
import { TransactionFilterType } from "src/shared/components/Filters/types"

/*
 STYLES
*/

const StyledFilterContentSection = styled(FilterContentSection)`
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 240px;
`

const Checkbox = styled(FilterCheckbox)``

const DimensionActivityButton = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  &:hover {
    ${Checkbox} {
      border-color: ${colors.accentBlue};
      background-color: ${colors.white};
    }
  }
`

/*
 INTERFACES
*/

interface FilterByProps {
  selectedActivity: DimensionActivity | undefined
  toggleActivity: (activity: DimensionActivity) => void
}

/*
 COMPONENTS
*/

export const FilterByDimensionActivity: React.FC<FilterByProps> = ({
  selectedActivity,
  toggleActivity,
}) => {
  const activities = React.useMemo(() => Object.values(DimensionActivity), [])

  return (
    <FilterAccordionItem value={TransactionFilterType.DimensionActivity}>
      <FilterAccordionHeader Icon={SvgActivity} count={0}>
        Activity
      </FilterAccordionHeader>
      <FilterAccordionContent>
        <StyledFilterContentSection>
          {activities.map((activity) => (
            <DimensionActivityButton key={activity} onClick={() => toggleActivity(activity)}>
              {activity}
              <Checkbox
                checked={activity === selectedActivity}
                onChange={() => toggleActivity(activity)}
              />
            </DimensionActivityButton>
          ))}
        </StyledFilterContentSection>
      </FilterAccordionContent>
    </FilterAccordionItem>
  )
}
